// extracted by mini-css-extract-plugin
module.exports = {"cancelButton":"UpdateOrderNote_cancelButton__2SnUJ"};